<template>
  <div>
    <rl :rd="routerData"></rl>
    <div class="about container">
      <h1 class="text-center">{{ data.title }}</h1>
      <div class="other">
        <span
          ><img class="titleImg" src="../../assets/img/time.png" />
          {{ data.create_time_text }}</span
        >
        <div class="sharelink">
          <a href="http://v.qq.com/vplus/nangua/videos"
            ><img src="../../assets/img/detail/c1.png"
          /></a>
          <a href="https://weibo.com/infzm"
            ><img src="../../assets/img/detail/c2.png"
          /></a>
          <a href="https://www.ximalaya.com/zhubo/194050845"
            ><img src="../../assets/img/detail/c3.png"
          /></a>
        </div>
      </div>
      <div class="swiper-container" id="imageSwiper">
        <div class="swiper-wrapper ">
          <div
            class="swiper-slide"
            v-for="(val, key) in data.images"
            :key="key"
          >
            <!-- :src="val.url+'?x-oss-process=image/resize,w_1600'" -->
            <img
              :data-src="val.url + '?x-oss-process=image/resize,w_1600'"
              class="swiper-lazy"
            />
           
          </div>
        </div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-" id="image-prev"></div>
        <div class="swiper-button-" id="image-next"></div>
        <div class="swiper-lazy-preloader swiper-lazy-preloader-black" style="z-index:0;"></div>
        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>
      <div class="swiper-container gallery-thumbs" id="thumbSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(val, key) in data.images"
            :key="key"
          >
            <img :src="val.url + '?x-oss-process=image/resize,w_200'" />
          </div>
        </div>
        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev" id="thumb-prev"></div>
        <div class="swiper-button-next" id="thumb-next"></div> -->
      </div>
      <div class="backhome">
        <router-link :to="'/image/1'" tag="a">更多图集</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import header from "../public/header.vue";
import footer from "../public/footer.vue";
import rl from "../public/routerlink.vue";
import Swiper from "swiper";
import { log } from "util";
export default {
  components: {
    rl
  },
  data() {
    return {
      data: {},
      bannerSwiper: "",
      thumbSwiper: "",
      bannerSwiperOption: {
        loop: true, // 循环模式选项
        navigation: {
          nextEl: "#image-next",
          prevEl: "#image-prev"
        },
        // 如果需要滚动条
        scrollbar: {
          el: ".swiper-scrollbar"
        }
      },
      routerData: [{ title: "精彩图集", link: "/image/1" }],
      get: {
        id: "",
        name: "fashion"
      }
    };
  },
  created() {
    this.get.id = this.$route.params.id;
    this.$http.get("/Index/index/data", { params: this.get }).then(res => {
      // if (res.datas.images) {
      //   res.datas.images = eval("(" + res.datas.images + ")");
      // }
      // this.routerData.push({'title':res.datas.title})
      this.data = res.datas;
    });
  },
  methods: {
    SwiperReady() {
      if (this.bannerSwiper) {
        this.bannerSwiper.destroy();
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.thumbSwiper = new Swiper("#thumbSwiper", {
            spaceBetween: 10,
            slidesPerView: 6,
            loop: true,
            freeMode: true,
            loopedSlides: 5, //looped slides should be the same
            watchSlidesVisibility: true,
            // navigation: {
            //   nextEl: "#thumb-next",
            //   prevEl: "#thumb-prev"
            // },
            watchSlidesProgress: true
          });

          this.bannerSwiper = new Swiper("#imageSwiper.swiper-container", {
            loop: true, // 循环模式选项
            lazy: true,
            navigation: {
              nextEl: "#image-next",
              prevEl: "#image-prev"
            },
            scrollbar: {
              el: ".swiper-scrollbar"
            },
            loop: true,
            thumbs: {
              swiper: this.thumbSwiper
            }
          });
        }, 200);
      });
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.SwiperReady();
      })();
    };
    //
    this.$nextTick(() => {
      setTimeout(() => {
        this.SwiperReady();
      }, 1000);
    });
  }
};
</script>
<style lang="less" scoped>
.swiper-slide {
  height: 100%;
  position: static !important;
}

h1 {
  border-bottom: 1px solid #bfbfbf;
  padding-bottom: 30px;
}

.other {
  margin: 30px 0;
  overflow: hidden;
  @lh: 36px;
  @w: 16px;
  line-height: @lh;
  .sharelink {
    float: right;
    img {
      width: @w+5;
      margin: 0 5px;
    }
  }
  span {
    text-indent: 20px;
    margin: 0 10px;
    img {
      // float: left;
      margin-right: 10px;
      width: @w;
      height: @w;
    }
  }
}
.banner {
  img {
    width: 100%;
  }
}
.content {
  margin-top: 10px;
}

#image-prev {
  background-image: url("../../assets/img/sw.png");
  background-repeat: no-repeat;
  position: absolute;
  top: 50%;
  width: calc(var(--swiper-navigation-size) / 44 * 44);
  height: var(--swiper-navigation-size);
  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);
  z-index: 10;
  left: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 100%;
}
#image-next {
  background-image: url("../../assets/img/sw.png");
  background-repeat: no-repeat;
  position: absolute;
  top: 50%;
  width: calc(var(--swiper-navigation-size) / 44 * 44);
  height: var(--swiper-navigation-size);
  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);
  z-index: 10;
  right: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 100%;
  transform: rotate(180deg);
}
.about {
  justify-content: center;
  min-height: 500px;
  margin: 30px auto;
  /deep/ img {
    max-width: 100%;
  }
}
.vlbox {
  width: 400px;
  height: 400px;
  margin: 50px;
  border: 2px rsolid #bfbfbf;
  padding: 30px;
  h3 {
    height: 44px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(124, 124, 124, 1);
    opacity: 1;
    border-bottom: 1px dotted #bfbfbf;
  }
}
.backhome {
  text-align: center;
  clear: both;
  margin-top: 20px;
  a {
    padding: 10px 20px;
    border: 1px solid #ef5050;
    color: #ef5050;
    display: inline-block;
  }
}
.swiper-slide-thumb-active{
  border:3px solid red;
}
#thumbSwiper {
  margin-top: 10px;
  .swiper-slide{
    text-align: center;
  }
}
@media (min-width: 765px) {
  .content {
    padding: 0 50px;
  }
}
@media (max-width: 765px) {
  .other {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .source {
      display: block;

      width: 100%;
    }
    span {
      text-indent: 0;
    }
    .sharelink {
      float: none;
    }
  }
}
</style>